import {
  type EoReader,
  PacketAction,
  PacketFamily,
  WarpAgreeServerPacket,
  WarpEffect,
  WarpRequestServerPacket,
  WarpType,
} from 'eolib';
import type { Client } from '@/client';
import { resetPvp } from '@/pvp';
import { ADMIN_WARP_LEAVE_EFFECT_ID } from '@/consts';
import { getEmf } from '@/db';
import { EOResourceID } from '@/edf';
import { EffectAnimation, EffectTargetCharacter } from '@/render';
import { SfxId } from '@/sfx';
import { ChatChannels, ChatIcon } from '@/ui/enums';

function handleWarpRequest(client: Client, reader: EoReader) {
  resetPvp(client);
  void client.sessionController.beginWarp(WarpRequestServerPacket.deserialize(reader));
}
function handleWarpAgree(client: Client, reader: EoReader) {
  void client.sessionController.finishWarp(WarpAgreeServerPacket.deserialize(reader));
}

export function registerWarpHandlers(client: Client) {
  client.bus!.registerPacketHandler(
    PacketFamily.Warp,
    PacketAction.Request,
    (reader) => handleWarpRequest(client, reader),
  );
  client.bus!.registerPacketHandler(
    PacketFamily.Warp,
    PacketAction.Agree,
    (reader) => handleWarpAgree(client, reader),
  );
}
